import React from "react";

export default function Wrapper({ children }) {
  return <section className="wrapper">{children}</section>;
}
